import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockLinkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockLink",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.98 24.75V7.25A5.3 5.3 0 0 0 24.73 2H7.24C4.34 2.03 2 4.4 2 7.3v17.45A5.313 5.313 0 0 0 7.24 30h17.51c2.88-.03 5.21-2.37 5.24-5.25zm-8.4-.94c0 1.61-1.31 2.9-2.92 2.9h-5.3a2.92 2.92 0 0 1-2.92-2.9v-5.23a1.401 1.401 0 0 1 2.79-.25v5.47c0 .07.06.12.13.12h5.3c.07 0 .12-.05.13-.12v-5.23a1.401 1.401 0 0 1 2.79-.25v5.47Zm-6.98-3.72v-9.05a1.401 1.401 0 0 1 2.79-.25v9.29a1.401 1.401 0 0 1-2.79.25zm6.98-7.55a1.401 1.401 0 0 1-2.79.25V7.32c0-.07-.06-.12-.13-.12h-5.3c-.07 0-.12.05-.13.12v5.23a1.401 1.401 0 0 1-2.79.25V7.33c0-1.61 1.31-2.9 2.92-2.9h5.3c1.61 0 2.91 1.3 2.92 2.9v5.23Z"
    })
  }));
};